var _circle, _path, _path2, _g, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInmateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "88px",
    height: "95px",
    viewBox: "0 0 88 95",
    enableBackground: "new 0 0 88 95",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#36556F",
    cx: 43.408,
    cy: 50.264,
    r: 6.309
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36556F",
    d: "M46.302,54.367c0,0-5.219-1.708-5.692,0.711c-0.425,2.164-2.277,12.951-2.277,12.951h10.391L46.302,54.367z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#D15C5D",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M80.83,6.75v44.33h-0.01c0,0.16,0.01,0.32,0.01,0.48 c0,17.61-37.33,39.41-37.33,39.41s-36-21.8-36-39.41c0-0.16,0.01-0.32,0.01-0.48H7.5V6.75H80.83z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D15D5D",
    d: "M5.5,6.75v2.49l38.47,27.55l34.86-26.64v-3.4H5.5z M43.9,31.82L11.68,8.74h62.41L43.9,31.82z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.251,
    y: 17.144,
    transform: "matrix(0.5412 0.8409 -0.8409 0.5412 34.3171 -1.1926)",
    fill: "#D15D5D",
    width: 4,
    height: 27.417
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.419,
    y: 17.478,
    transform: "matrix(-0.5412 0.8409 -0.8409 -0.5412 133.2148 -10.3082)",
    fill: "#D15D5D",
    width: 4,
    height: 27.417
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInmateLogo);
export default __webpack_public_path__ + "static/media/inmate-logo.189830de3880237d3f509af8cbe65093.svg";
export { ForwardRef as ReactComponent };